module.exports = __webpack_public_path__ + "img/normal-logo.04141f0a.png";